import React from 'react'
import moment from 'moment'
import { useNavigate, useParams } from 'react-router-dom'

import {
  dealsPath,
  makeSearchPath,
  carModelDisplayLabel,
  customerDisplayLabel,
} from '@/utils'
import { DealNode } from '@/apollo/graphql'
import { useApp } from '@/hooks'
import { t } from '@/i18n'

const colors = ['#36af69', '#36af69', '#ff4a44', '#ff9c41']
const statuses = ['OPEN', 'CLOSED', 'CANCELED', 'RENT']

const DealsRow: React.FC<{
  node: DealNode
}> = ({ node }) => {
  const { isRTL } = useApp()
  const navigate = useNavigate()
  const { customerId } = useParams()

  const color = colors[statuses.indexOf(node?.status || '')]
  return (
    <tr
      onClick={() =>
        navigate(
          makeSearchPath(dealsPath, {
            customerId,
            id: node.id,
          }),
        )
      }
    >
      <td>{node?.id}</td>
      <td>{moment(node?.startDate).format('DD/MM/YYYY')}</td>
      <td>
        <span style={{ color }}>{t(node?.status || '')}</span>
      </td>
    </tr>
  )
}

export default DealsRow
